import store from '@/store';

// Global navigation guard: enforce authentication on routes flagged requiresAuth.
// Extracted from index.js so it can be unit-tested without importing every view.
// - token still valid, not near expiry  -> proceed
// - token valid but near expiry          -> refresh; if the user is gone, go to /login
// - token expired                        -> clear the user and go to /login
// - route not protected                  -> proceed
export async function authGuard(to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const timeToExpire = store.getters.timeToExpire;
    if (timeToExpire > 0) {
      if (store.getters.willExpireSoon) {
        await store.dispatch('refreshToken');
        if (!store.state.user) {
          return next({ path: '/login' });
        }
      }
      next();
    } else {
      store.commit('clearUser');
      next({ path: '/login' });
    }
  } else {
    next();
  }
}
